<template>
<div class="input_field_wrap animate_class">
<div class="grid custom_input_wrap mr-0 ml-0">

<div class="col-12">
<p class="text-primary font-bold">
{{question}}
</p>

</div>

<template v-if="nonconformity_status=='loading'">
<FrameOverlay></FrameOverlay>
</template>

<template v-if="nonconformity_status=='accepted'">
<div class="col-12">
<p class="text-green-500 font-bold">Son doğrulama kaydı kabul edildi. Bu soru ile ilgili uygunsuzluk kapatıldı.</p>
</div>
</template>

<template v-if="nonconformity_status=='pending'">
<div class="col-12">
 <span class="material-icons md-36s ml-3 text-red-700">
    warning
    </span>  
<p class="text-red-700 font-bold">Son doğrulama kaydı kontrol edilmeyi bekliyor.</p>
<hr>
</div>
<div class="col-12">
<p class="font-bold text-primary">Son doğrulama kaydı.</p>
<p class="">{{nonconformity.lastclosurerequest.text}}</p>
</div>
</template>


<template v-if="nonconformity_status=='rejected'">
<div class="col-12">
<p class="text-red-700 font-bold">Son doğrulama kaydı reddedildi.</p>
</div>
</template>

<template v-if="nonconformity.evidences.length">
<p class="font-bold text-primary">Yüklenen kanıt dosyaları</p>


<div class="col-12" v-for="item in nonconformity.evidences">
<div class="grid">
<div class="col-10" >
<a class="p-text-secondary" :href="apiurl+item.filepath" target="_blank">{{item.filename}}</a>
</div>

<div class="col-2">
<Button  icon="pi pi-trash"  @click="deleteEvidence(item.id)" class=" p-button-danger p-button-outlined  p-button-sm" :loading="deleting"/> 
</div>

</div>
</div>


<div class="col-12">

<Button label="Soruyu Göster" icon="pi pi-check" @click="showQuestion"  v-if="!show_question" class=" p-button-primary p-button-outlined  p-button-sm"  />

<Button label="Soruyu Gizle" icon="pi pi-check" @click="hideQuestion"  v-if="show_question" class=" p-button-primary p-button-outlined  p-button-sm"  />
</div>

</template>



<template v-if="nonconformity_status=='awaiting'">
<div class="col-12">
<p class="text-purple-500 font-bold">Henüz doğrulama kaydı oluşturulmadı.</p>
</div>

</template>





</div>

<div class="col-12 " v-if="show_question">
<CustomInputfield :data="nonconformity.inputfield"></CustomInputfield>
</div>

</div>	
</template>

<script>
export default {

  name: 'NonconformityClosurePanel',
  props:["nonconformity","nonconformity_types"],
  data () {
    return {
      text:null,
      files:[],
      showuploader:false,
      deleting:false,
      show_question:false,
    }
  },
  computed:{
  	question()
  	{
  		if(this.nonconformity.inputfield)
  		{
  			if(this.nonconformity.inputfield.translations.length)
  			{
  				 let translation = this.nonconformity.inputfield.translations.find((item)=>{return item.language_id == this.$store.state.auth.user.preflang_id})
  				 if(translation)
	            {
	              return translation.translation
	            }
	            else
	            {
	              return this.nonconformity.inputfield.name
	            }
  			}
  			else
  			{
  				return this.nonconformity.inputfield.name
  			}
  		}
  		return ""
  	},
    nonconformity_status()
    {
      if(this.nonconformity )
      {
        if(this.nonconformity.status=="open")
        {
            if(this.nonconformity.lastclosurerequest)
            {
              if(this.nonconformity.lastclosurerequest.status=="pending")
              {
                return "pending"
              }
              if(this.nonconformity.lastclosurerequest.status=="rejected")
              {
                return "rejected"
              }
            }
            else
            {
              return "awaiting"
            }
        }
        else
        {
          return "accepted"
        }
        
      }

      return "loading"
    },
    apiurl()
    {
      let api =  process.env.VUE_APP_API_HOOK
      api = api.replace("/api/","/")
      return api
      //return "https://storage.googleapis.com/verifycloud/"
    },
  },
  methods:{
    showQuestion()
    {
      this.show_question = true
    },
    hideQuestion()
    {
      this.show_question = false
    },
    deleteEvidence(id)
    {
      this.deleting = true
      let formdata = new FormData()
      this.generalSubmission(formdata,"delete_nonconformity_evidence/"+id,this.afterSubmit)
    },
    onFilesAdded(event)
    {
      this.files = []
      for(let file of event.files)
      {
        this.files.push(file)
      }
    },
    showUploader()
    {
      this.showuploader = true
    },
    hideUploader()
    {
      this.files = []
      //this.$refs.cover_image.value = ''
      this.showuploader = false
    },
    submit()
    {
      
      if(this.text=="" || !this.text)
      {
        this.has_error = true
        this.submitting = false
        return  false
      }
      let formdata = new FormData()
      formdata.append("text",this.text)
      formdata.append("flowsupplier_id",this.$route.params.id)
      for( var i = 0; i < this.files.length; i++ ){
        let file =  this.files[i];
        formdata.append('files[' + i + ']', file);
      }
      
      //return false
      this.generalSubmission(formdata,"submit_nonconformity_closure_request/"+this.nonconformity.id,this.afterSubmit)
    },
    afterSubmit(response)
    {
      this.deleting = false
      this.text = null
      this.files = []
      this.hideUploader()
      this.$emit("nonconformityDataUpdated",response.data)
      
    },
  }
}
</script>

<style lang="css" scoped>
</style>